import styled from 'styled-components'

import { TradeSettingsQuick } from '@root/entities/trade-settings/model'

import { QuickBuyInputSection } from './quick-buy-input-section'

import type { ClassNameProps } from '@root/shared/react'

type QuickBuyPresetPopoverProps = {} & ClassNameProps

export const QuickBuySectionsInputs: React.FC<QuickBuyPresetPopoverProps> = ({
  className,
}) => {
  return (
    <Sections className={className}>
      {TradeSettingsQuick.sections.map((section) => (
        <QuickBuyInputSection key={section} section={section} />
      ))}
    </Sections>
  )
}

const Sections = styled.div`
  display: grid;
  gap: 6px;
`
